// extracted by mini-css-extract-plugin
export default {"solarSystemTypeContainer":"solar-solution-type_solarSystemTypeContainer__nc5zK"};